import React from 'react';
import Banner from '../../views/header/Banner';

const Header: React.FC = () => {
  return (
    <div>
      <Banner />
    </div>
  );
};

export default Header;
